// This import handles the show password option in the wifi network list
import {handleShowPasswordIconButtonPress, handleAllShowPasswordIconButtonPress} from "../wifi_networks/wifi_list_functions"
import initInstantImageUpload from "../shared_functions/instant_image_upload"
import {hideColorWarnings, updateBackgroundWarning} from '../shared_functions/color_functions'
document.addEventListener('turbolinks:load', () => {

    // identifier
    const byodAppForm = document.getElementById('byodAppForm')

    const homeView = document.getElementById('homeView')
    const listViewEnabledContainer = document.getElementById('listViewEnabledContainer')
    const numbPadEnabledContainer = document.getElementById('numbPadEnabledContainer')

    if(byodAppForm !== null) {
        if (homeView !== null && listViewEnabledContainer !== null && numbPadEnabledContainer !== null) {
            homeView.addEventListener('change', changeHomeView)
        }

        // wifi password
        handleAllShowPasswordIconButtonPress()

        // Is triggered by the AJAX call of the wifi_networks to add the eventListener on showPassword again
        document.addEventListener('wifi:row:replaced', (e) => {
            handleShowPasswordIconButtonPress(e.detail.showPasswordIcon, e.detail.showPassword);
        });

        let urlSegment = "byod_apps"
        let uploadIds = ["byodAppBackground", "byodAppLogo", "byodAppFont", "byodWelcomeScreenBackground", "byodWelcomeScreenLogo"]
        initInstantImageUpload("byodAppLogo", urlSegment, uploadIds.filter(id => id !== "byodAppLogo"))
        initInstantImageUpload("byodWelcomeScreenLogo", urlSegment, uploadIds.filter(id => id !== "byodWelcomeScreenLogo"))

        initInstantImageUpload("byodAppBackground",
            urlSegment,
            uploadIds.filter(id => id !== "byodAppBackground"),
            () => disableBackgroundColor("byodAppBackgroundColor", "noValidColorMessageBackground", "byodAppUiColor"))
        initInstantImageUpload("byodWelcomeScreenBackground",
            urlSegment,
            uploadIds.filter(id => id !== "byodWelcomeScreenBackground"),
            () => disableBackgroundColor("byodWelcomeScreenBackgroundColor", "noValidColorMessageWelcomeScreenBackground", "byodWelcomeScreenUiColor"))

        // disable background color if a background image exists
        const byodAppBackgroundImg = document.getElementById("byodAppBackgroundImg")
        if (byodAppBackgroundImg !== null) {
            disableBackgroundColor("byodAppBackgroundColor", "noValidColorMessageBackground", "byodAppUiColor")
        }
        const byodWelcomeScreenBackgroundImg = document.getElementById("byodWelcomeScreenBackgroundImg")
        if (byodWelcomeScreenBackgroundImg !== null) {
            disableBackgroundColor("byodWelcomeScreenBackgroundColor", "noValidColorMessageWelcomeScreenBackground", "byodWelcomeScreenUiColor")
        }
    }

    function changeHomeView(){
        if(homeView.value === "list"){
            numbPadEnabledContainer.__x.$data.disabled = false
            listViewEnabledContainer.__x.$data.disabled = true
        } else if (homeView.value === "numb_pad"){
            listViewEnabledContainer.__x.$data.disabled = false
            numbPadEnabledContainer.__x.$data.disabled = true
        }
    }

    /**
     * Disables the background color input fields when a background image is present.
     * @param {string} id - The base ID of the background color field (e.g., "byodAppBackgroundColor" or "byodWelcomeScreenBackgroundColor")
     * @param {string} messageId - The ID of the error message element to hide (e.g., "noValidColorMessageBackground" or "noValidColorMessageWelcomeScreenBackground")
     * @param {string} uiColorId - The ID of the UI color field to check for color contrast warnings (e.g., "byodAppUiColor" or "byodWelcomeScreenUiColor")
     */
    function disableBackgroundColor(id, messageId, uiColorId){
        const backgroundColorLabel = document.getElementById(`${id}Label`);
        const backgroundColorPreview = document.getElementById(`${id}Preview`);
        const backgroundColorTextField = document.getElementById(`${id}TextField`);
        const noValidBackgroundColorMessage = document.getElementById(messageId);
        const backgroundColorColorField = document.getElementById(`${id}ColorField`);

        if (backgroundColorLabel !== null && backgroundColorPreview !== null && backgroundColorTextField !== null &&
            noValidBackgroundColorMessage !== null && backgroundColorColorField !== null) {

            backgroundColorLabel.classList.remove("text-gray-700")
            backgroundColorLabel.classList.add("text-gray-400")
            noValidBackgroundColorMessage.classList.add('hidden');
            backgroundColorTextField.classList.add("text-gray-500")
            backgroundColorTextField.disabled = true
            backgroundColorPreview.style.fill = '#FFFFFF';
            backgroundColorColorField.disabled = true

            hideColorWarnings(id)
            updateBackgroundWarning(uiColorId, backgroundColorTextField)
        }
    }
});